import { useTranslation } from "react-i18next"

import { useInstallPrompt } from "src/utils/install"
import { useIsPhone } from "src/utils/viewport"

import "./InstallPrompt.css"

/* The offer to put the game on a home screen.
 *
 * Phone shell only. A desktop Chromium can install too, and deliberately is not asked: on a
 * desktop the address bar already carries the install button, and a banner over a game whose
 * bottom edge is the chat input costs more than it offers. The shell is the right question here
 * rather than the pointer, because this is about where the banner *fits*.
 *
 * The three modes come from `utils/install` and each is a different sentence, not a different
 * amount of enthusiasm: on Chromium there is a button that opens the real dialog, on iOS Safari
 * there is no API and the player has to be told where the menu item is, and inside somebody
 * else's webview even that menu item is missing. */
const InstallPrompt = () => {
  const { t } = useTranslation()
  const isPhone = useIsPhone()
  const { promptMode: mode, promptInstall, dismiss } = useInstallPrompt()

  if (!isPhone || mode === "none") return null

  return (
    <div className="install-prompt" role="region" aria-label={t("install.title")}>
      <img src="/pwa/icon-192.png" alt="" className="install-prompt-icon" />
      <div className="install-prompt-body">
        <p className="install-prompt-title">{t("install.title")}</p>
        <p className="install-prompt-text">
          {mode === "manual-ios"
            ? t("install.ios")
            : mode === "open-in-safari"
              ? t("install.openInSafari")
              : t("install.body")}
        </p>
        <div className="install-prompt-actions">
          {mode === "prompt" ? (
            <button type="button" onClick={() => promptInstall()}>
              {t("install.action")}
            </button>
          ) : null}
          <button type="button" className="quiet" onClick={dismiss}>
            {t("install.dismiss")}
          </button>
        </div>
      </div>
    </div>
  )
}

export default InstallPrompt
